import { Fragment } from 'react'
import classNames from 'classnames'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'
import { EMAIL_ATTACHED_THREADS_MODAL_TABLE_ROW_ACTIONS_CONFIG } from '../EmailAttachedThreadsModal.constants'

import { renderCell } from './EmailAttachedThreadsModalTableRow.utils.js'

import * as styles from './EmailAttachedThreadsModalTableRow.module.css'

function EmailAttachedThreadsModalTableRow({
  Actions = TableRowActions,
  actionsColumnWidth,
  attachedFilesProps,
  columns,
  disabled,
  emptyColumnSize,
  isSelected,
  item,
  readonly,
  onClick,
  onMouseDown,
  ...restProps
}) {
  const { uuid } = item

  const { handleMouseEnter, handleMouseLeave, handleSelect } =
    useTableRowActions(
      { item, ...restProps },
      EMAIL_ATTACHED_THREADS_MODAL_TABLE_ROW_ACTIONS_CONFIG
    )

  function handleClick(event) {
    onClick?.(uuid, event)
  }

  function handleMouseDown(event) {
    onMouseDown?.(uuid, event)
  }

  const rowClass = useTableRowModClassName({
    className: classNames(styles.EmailAttachedThreadsModalTableRow, {
      [styles.readonly]: readonly,
    }),
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <div
      {...qaProps}
      className={rowClass}
      key={item.id}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          checked={isSelected}
          disabled={disabled}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            attachedFilesProps,
            item,
            name: column.name,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default EmailAttachedThreadsModalTableRow
